import { useEffect, useState, useContext } from 'react';
import { useSearchParams } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import { RequestAccessFormContext } from '../../contexts/request-access-form-context';

const useGoogleConnectQueryParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [isError, setIsError] = useState(false);
    const { setStep, setDirectoryUserAccountId, setDirectoryUserAccountSecret, setUserEmail } =
        useContext(RequestAccessFormContext);

    useEffect(() => {
        // if we are in the google connect step and the query params are set
        if (
            searchParams.get('success') === 'true' &&
            searchParams.has('directoryUserAccountId') &&
            searchParams.has('directoryUserAccountSecret') &&
            searchParams.has('email')
        ) {
            setStep(2);

            setDirectoryUserAccountId(Number(searchParams.get('directoryUserAccountId')));
            setDirectoryUserAccountSecret(searchParams.get('directoryUserAccountSecret') || '');
            setUserEmail(searchParams.get('email') || '');

            // delete whole query param
            setSearchParams({});
        } else if (searchParams.has('error')) {
            setStep(1);
            setIsError(true);
        }
    }, [
        searchParams,
        setSearchParams,
        setStep,
        setDirectoryUserAccountId,
        setDirectoryUserAccountSecret,
        setUserEmail,
    ]);

    useEffect(() => {
        if (isError) {
            Sentry.captureMessage(
                JSON.stringify({
                    title: 'useGoogleConnectQueryParams()',
                    data: JSON.stringify(searchParams),
                    error: isError,
                }),
                'error'
            );
        }
    }, [isError, searchParams]);

    return { isError };
};

export { useGoogleConnectQueryParams };
